import React, { useContext } from "react";
import { Menu, Grid, Container } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import BreadcrumbContainer from "../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionHome } from "../../app/util/breadcrumbOptions";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Role } from "../../app/util/role";
import { observer } from "mobx-react-lite";

const Configuration: React.FC = () => {
  let navigate = useNavigate();

  const match = {
    url: '/home/Configuration'
  };

  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;

  document.title = "Configuración";
  return (
    <div>
      <div className="configurationContent">
        <BreadcrumbContainer title="Configuración" sections={sectionHome} />
      </div>
      <div className="configurationContent">
        <Grid columns={2} stackable textAlign="center">
          <Grid.Row verticalAlign="top">
            <Grid.Column>
              <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">
                  Mi empresa
                </Menu.Item>
                <Menu.Item
                  name="Configuración general"
                  onClick={() => navigate(`${match.url}/DashboardCompany`)}
                >
                  <Container textAlign="left">Datos empresa</Container>
                </Menu.Item>

                <Menu.Item
                  name="Usuarios"
                  onClick={() => navigate(`${match.url}/DashboardUsers`)}
                >
                  <Container textAlign="left">Usuarios</Container>
                </Menu.Item>
              </Menu>
            </Grid.Column>           
            <Grid.Column key="configurat">
            {user?.role===Role.Sudo && <Menu vertical fluid className="configurationMenu">
                <Menu.Item header className="firstLineConfig">
                  Agentes comerciales
                </Menu.Item>
                <Menu.Item
                  name="resaluciones"
                  onClick={() =>
                    navigate(`${match.url}/Broker/DashboardBroker`)
                  }
                >
                  <Container textAlign="left">Agentes comerciales</Container>
                </Menu.Item>
                <Menu.Item
                  name="vendedores"
                  onClick={() =>
                    navigate(`${match.url}/Seller/DashboardSeller`)
                  }
                >
                  <Container textAlign="left">Vendedores</Container>
                </Menu.Item>
              </Menu> }
              
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </div>
  );
};

export default observer(Configuration);
